import IBModuleApi from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

export const getCategory = async () => {
    const { data } = await IBModuleApi.get(
        `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master-category`
    );

    return data;
};

export const getCatalogs = async () => {
    const { data } = await IBModuleApi.get(
      `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master`
    );
  
    return data;
  };
  
  
  export const createCatalogs = async (createInfo: any) => {
    const { data } = await IBModuleApi.post(
      `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master`,
      createInfo
    );
  
    return data;
  };
  
  export const updateCatalogs = async (updateInfo: any) => {
    const { data } = await IBModuleApi.put(
      `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master/${updateInfo?.id}`,
      {
        ...updateInfo,
        id: undefined,
      }
    );
  
    return data;
  };
  
  export const deleteCatalogs = async (deleteInfo: any) => {
    const { data } = await IBModuleApi.delete(
      `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master/${deleteInfo?.id}`
    );
  
    return data;
  };
  
  export const reactiveCatalogs = async (reactiveInfo: any) => {
    const { data } = await IBModuleApi.put(
      `${process.env['REACT_APP_MASTER_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.mastercatalog}/iuvibanking-console-api-master/rest/1.0/master/${reactiveInfo?.id}/reactivate`
    );
  
    return data;
  };
